import {
    defineComponent,
    onMounted,
    ref
} from "vue";

import StatsCard        from "./statsCard.jsx";
import { useFetch }     from "../utils.js";
import { StatsElementType } from "./dashboard/model.js";


//////////////////////////////////////////////////
//  HOME
//////////////////////////////////////////////////


export default defineComponent({

    setup() {
        const { fetch }         = useFetch();
        const dashboardElements = ref<StatsElementType[]>([]);
        const refTimeRange      = ref(60 * 60_000);
        const refVisiblePoints  = ref(25);

        const timeRanges = [
            [  "5M",        5 * 60_000 ],
            [ "15M",       15 * 60_000 ],
            [ "30M",       30 * 60_000 ],
            [  "1H",       60 * 60_000 ],
            [  "1J",  24 * 60 * 60_000 ],
        ] as const;

        const visiblePoints = [
            [  "10",  10 ],
            [  "25",  25 ],
            [  "50",  50 ],
            [ "100", 100 ],
        ] as const;

        onMounted(async () => {
            const [ dashboards ] = await Promise.all([
                fetch("/api/dashboard-stats").then((res) => res.json()),
            ]);

            dashboardElements.value = dashboards;
        });

        return () => (
            <div id="app" class="home-dashboard">
                <header class="home-hero">
                    <div class="home-hero-copy">
                        <span class="home-eyebrow">LogsCord intelligence</span>
                        <h1>Observabilité Discord, nette et exploitable.</h1>
                        <p>
                            Dashboards, profils et graphes relationnels dans une interface plus cohérente, plus plate, plus lisible.
                        </p>
                    </div>

                    <div class="home-hero-metrics">
                        <div>
                            <span>{dashboardElements.value.length}</span>
                            <small>dashboards</small>
                        </div>

                        <div>
                            <span>{refVisiblePoints.value}</span>
                            <small>points</small>
                        </div>

                        <div>
                            <span>{timeRanges.find(([, value ]) => value === refTimeRange.value)?.[0] ?? "1H"}</span>
                            <small>fenêtre</small>
                        </div>
                    </div>
                </header>

                <div class="home-dashboard-controls">
                    <div class="home-control-card">
                        <div class="home-control-label">Points</div>

                        <div class="home-segmented-control">
                            {visiblePoints.map(([ label, value ]) => (
                                <button class={{ "home-segment": true, "home-segment-active": refVisiblePoints.value === value }} onClick={() => refVisiblePoints.value = value}>
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div class="home-control-card">
                        <div class="home-control-label">Fenêtre</div>

                        <div class="home-segmented-control">
                            {timeRanges.map(([ label, value ]) => (
                                <button class={{ "home-segment": true, "home-segment-active": refTimeRange.value === value }} onClick={() => refTimeRange.value = value}>
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <router-link to="/dashboards/new" class="home-primary-action">
                        <i class="material-symbols-outlined">add_chart</i>
                        <span>Créer un dashboard</span>
                    </router-link>
                </div>

                <div class="home-dashboard-list">
                    {dashboardElements.value.map((element, index) => (
                        <StatsCard
                            index={index}
                            element={element}
                            timeRange={refTimeRange.value}
                            visiblePoints={refVisiblePoints.value}
                            key={element.id ?? index}
                        />
                    ))}
                </div>
            </div>
        );
    },
});
